import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { GraphQL } from '@guestgoodie/graphql'
import { useLocation } from 'wouter'
import { HugeiconsIcon, HugeiconsIconProps } from '@hugeicons/react'
import { useLingui } from '@lingui/react/macro'

import {
  CalendarFavorite01Icon,
  ServiceIcon,
  Video01Icon
} from '@hugeicons/core-solid-rounded'

import { CheckPermission, Permission } from '@/features/auth'
import { AddButton } from '@/components/ui/IconButton'
import { popoverContainer } from '@/utils/popovers'

function Item({
  text,
  Icon,
  onClick
}: {
  text: string
  Icon: HugeiconsIconProps['icon']
  onClick: () => void
}) {
  return (
    <DropdownMenu.Item
      className="flex cursor-pointer flex-row items-center gap-2.5 rounded-small px-4 py-2 text-regular outline-hidden focus:bg-primary-bright"
      onClick={onClick}
    >
      <HugeiconsIcon icon={Icon} className="size-4" />
      <span>{text}</span>
    </DropdownMenu.Item>
  )
}

export function AddGoodieButton() {
  const [, navigate] = useLocation()
  const { t } = useLingui()

  return (
    <CheckPermission
      permissions={[Permission.GOODIE_CREATE, Permission.GOODIE_UPDATE]}
    >
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <AddButton
            aria-label={t({
              comment:
                'Label for the Button that opens the popover to create a Goodie or a Promotion.',
              message: `Add Goodie`
            })}
          />
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal container={popoverContainer}>
          <DropdownMenu.Content
            className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 flex flex-col gap-3 rounded-small bg-white p-3 shadow-md outline-hidden z-popover"
            sideOffset={5}
          >
            <div className="flex flex-col gap-1">
              <Item
                Icon={ServiceIcon}
                text={t({
                  comment:
                    'Text of an Menu Item that will open the Dialog to create a new goodie of the type DEFAULT (Default)',
                  message: `Create Offer`
                })}
                onClick={() =>
                  navigate(`/create-goodie/${GraphQL.GoodieType.Default}`)
                }
              />
              <Item
                Icon={CalendarFavorite01Icon}
                text={t({
                  comment:
                    'Text of an Menu Item that will open the Dialog to create a new goodie of the type EVENT (Event/Weekplan)',
                  message: `Create Event/Weekplan`
                })}
                onClick={() =>
                  navigate(`/create-goodie/${GraphQL.GoodieType.Event}`)
                }
              />
              <Item
                Icon={Video01Icon}
                text={t({
                  comment:
                    'Text of an Menu Item that will open the Dialog to create a new goodie of the type MESSAGE (message)',
                  message: `Create Message`
                })}
                onClick={() =>
                  navigate(`/create-goodie/${GraphQL.GoodieType.Message}`)
                }
              />
            </div>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </CheckPermission>
  )
}
